import { ShieldAlert } from "lucide-react";

import { getCurrentRoles } from "@/lib/builder/permissions";

interface PagePermissionGuardProps {
  allowedRoles?: string[];
  children: React.ReactNode;
}

export function PagePermissionGuard({ allowedRoles, children }: PagePermissionGuardProps) {
  const roles = getCurrentRoles();

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.some((role) => roles.includes(role))) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-3 text-destructive">
        <ShieldAlert className="h-10 w-10" />
        <p className="text-sm font-medium">无权访问此页面</p>
        <p className="text-xs text-muted-foreground">当前角色：{roles.join(", ")}</p>
      </div>
    );
  }

  return <>{children}</>;
}
